module.exports = __webpack_public_path__ + "img/home-two-3.278c42f4.png";